export const mobile = '480px';
export const tablet = '800px';
export const desktop = '1400px';